import React from 'react';
import { SiProgress, SiAntdesign, SiNextdotjs } from 'react-icons/si';
import { FaGlobe, FaBrain, FaCode } from 'react-icons/fa';
import Title from '../layouts/Title';
import Card from './Card';
import { motion } from 'framer-motion';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-gray-800 relative overflow-hidden"
    >
      {/* Live Background */}
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <motion.div
          animate={{ x: [0, 100, 0], y: [0, -50, 0], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
          className="absolute top-0 left-0 w-96 h-96 bg-designColor/20 rounded-full blur-[100px]"
        />
        <motion.div
          animate={{ x: [0, -100, 0], y: [0, 50, 0], opacity: [0.2, 0.4, 0.2] }}
          transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
          className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple-600/20 rounded-full blur-[120px]"
        />
      </div>

      <div className="relative z-10">
        <Title title="Features" des="What I Do" />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <Card
              title="AI-Powered Apps"
              des="Building intelligent applications by integrating LLMs and AI agents to automate workflows and enhance decision-making processes."
              icon={<FaBrain />}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <Card
              title="SaaS Ecosystems"
              des="Architecting scalable, multi-tenant SaaS platforms with secure authentication, subscription management, and robust API integrations."
              icon={<FaCode />}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <Card
              title="Software Developer"
              des="Optimizing React & Next.js applications for maximum speed, SEO, and interactivity, ensuring a buttery smooth user experience."
              icon={<SiNextdotjs />}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Card
              title="Interactive 3D Web"
              des="Creating immersive web experiences using Three.js and WebGL to bring products and stories to life in the browser."
              icon={<FaGlobe />}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <Card
              title="Technical SEO"
              des="Engineering websites that dominate search rankings through Core Web Vitals optimization, semantic HTML, and structured data."
              icon={<SiProgress />}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <Card
              title="UX Engineering"
              des="Bridging the gap between design and code with pixel-perfect attention to detail, motion design, and accessibility standards."
              icon={<SiAntdesign />}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Features;
